module.exports = __webpack_public_path__ + "img/erp_case1.2d44179a.png";